import { connect } from 'react-redux';
import Shipment from './Shipment';
import {
  getShipment,
  getShipmentAccept
} from '../../store/actions/shipment';
import { getFieldsOrder, fieldsOrderInitialState } from '../../store/actions/fieldsOrder';
import {
  modalShipmentSubmergeOpen,
  modalShipmentReturnOpen,
  modalSKZipOpen,
  modalShipmentPlanOpen,
  modalShipmentPlanCancelOpen,
  modalShipmentCancelReasonOpen,
  modalShipmentRedeemConsignmentOpen,
  modalShipmentAddReportOverdueOpen,
  modalShipmentSZRebindingOpen,
  modalShipmentClientArrivalDateOpen
} from '../../store/actions/modal';

import { modalErrorOpen } from '../../store/actions/modalError';

const mapStateToProps = ({
  fieldsOrderReducer,
  settingsReducer,
  shipmentReducer,
  tabsReducer,
  userReducer
}) => ({
  fieldsOrderReducer,
  settingsReducer,
  shipmentReducer,
  tabsReducer,
  userReducer
});
const mapDispatchToProps = {
  getFieldsOrder,
  fieldsOrderInitialState,
  getShipment,
  getShipmentAccept,
  modalShipmentSubmergeOpen,
  modalShipmentReturnOpen,
  modalErrorOpen,
  modalSKZipOpen,
  modalShipmentPlanOpen,
  modalShipmentPlanCancelOpen,
  modalShipmentCancelReasonOpen,
  modalShipmentRedeemConsignmentOpen,
  modalShipmentAddReportOverdueOpen,
  modalShipmentSZRebindingOpen,
  modalShipmentClientArrivalDateOpen
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Shipment);
